<template>
  <div class="appointment-person-short-info">
    <h6 class="is-bold"> {{ title }} </h6>

    <div class="row">
      <div class="col-12 mb-2 clickable" @click=goToPersonFile>
        <span>{{ $t('clinical.people.name') }}:&nbsp;</span>
        <span class="is-bold">{{ fullName }}</span>
        &ensp;
        <i class="fa fa-external-link" aria-hidden="true"> </i>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('clinical.people.client_nr') }}:</span>&nbsp;
        <span class="is-bold" v-if="person.process_id">{{ person.process_id }}</span>
        <span class="is-bold" v-else>N/A</span>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('clinical.people.birthday') }}:</span>&nbsp;
        <span class="is-bold" v-if="person.birthdate && isValidBirthdate">{{ moment(person.birthdate).format('YYYY-MM-DD') }}</span>
        <span class="is-bold" v-else>N/A</span>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('people.inputs.phone') }}:</span>&nbsp;
        <span class="is-bold" v-if="person.phone || person.mobile_phone">{{ person.phone }}<span v-if="person.phone && person.mobile_phone"> / </span>{{ person.mobile_phone }}</span>
        <span class="is-bold" v-else>N/A</span>
      </div>

      <div class="col-12 mb-2">
        <span>{{ $t('clinical.people.address') }}:</span>&nbsp;
        <span class="is-bold" v-if="person.addresses.length && address">{{ address }}</span>
        <span class="is-bold" v-else>N/A</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    },
    person: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: function () {
        return this.$t('clinical.people.details')
      }
    }
  },
  computed: {
    fullName: function () {
      return this.person.last_name ? `${this.person.first_name} ${this.person.last_name}` : `${this.person.first_name}`
    },
    address: function () {
      if (!this.person.addresses.length) {
        return null
      }
      let lastAddress = this.person.addresses[this.person.addresses.length - 1]

      return [lastAddress.line1, lastAddress.line2, lastAddress.city, lastAddress.postal_code].filter(field => field).join(', ').trim()
    },
    isValidBirthdate: function () {
      if (!this.person.birthdate) {
        return false
      }
      return this.moment(this.person.birthdate).isValid()
    }
  },
  methods: {
    goToPersonFile: function () {
      setTimeout(() => {
        this.$router.push({ path: `/${this.serviceSlug}/clinical/people/${this.person.id}` })
      }, 500)
      this.$emit('closeAppointmentDetailsModal')
    }
  }
}
</script>
